import type {
  CartBundleDto,
  CartFeedingPlanDto,
  CartSkuDto,
  CartSubscriptionDto,
} from './schemas'
import { initContract } from '@ts-rest/core'
import z from 'zod'
import { ErrorResponseSchema, Identifier } from '../../shared/types'
import {
  CreateCartBundleBodySchema,
  CreateCartFeedingPlanBodySchema,
  UpsertCartSkuBodySchema,
} from './schemas'

const c = initContract()

const options = {
  pathPrefix: '/subscriptions',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

export const cartSubscriptionsContract = c.router({
  getSubscription: {
    method: 'GET',
    path: '/:subscriptionId',
    pathParams: z.object({
      subscriptionId: Identifier,
    }),
    responses: {
      200: c.type<CartSubscriptionDto>(),
    },
  },

  deleteSubscription: {
    method: 'DELETE',
    path: '/:subscriptionId',
    pathParams: z.object({
      subscriptionId: Identifier,
    }),
    responses: {
      200: c.type<CartSubscriptionDto>(),
    },
  },

  upsertSkuToSubscription: {
    method: 'PUT',
    path: '/:subscriptionId/skus/:productVariantId',
    pathParams: z.object({
      subscriptionId: Identifier,
      productVariantId: Identifier,
    }),
    body: UpsertCartSkuBodySchema,
    responses: {
      200: c.type<CartSkuDto>(),
    },
  },

  deleteSkuFromSubscription: {
    method: 'DELETE',
    path: '/:subscriptionId/skus/:productVariantId',
    pathParams: z.object({
      subscriptionId: Identifier,
      productVariantId: Identifier,
    }),
    responses: {
      204: c.noBody(),
    },
  },

  addBundleToSubscription: {
    method: 'POST',
    path: '/:subscriptionId/bundles',
    pathParams: z.object({
      subscriptionId: Identifier,
    }),
    body: CreateCartBundleBodySchema,
    responses: {
      201: c.type<CartBundleDto>(),
    },
  },

  addPlanToSubscription: {
    method: 'POST',
    path: '/:subscriptionId/plans',
    pathParams: z.object({
      subscriptionId: Identifier,
    }),
    body: CreateCartFeedingPlanBodySchema,
    responses: {
      201: c.type<CartFeedingPlanDto>(),
    },
  },
}, options)
